import type { QuickReply } from '../types';
import { h } from '../utils/dom';

type QuickReplyCallbacks = {
  onMessage: (content: string) => void;
  onWhatsApp: (value: string, label: string) => void;
  onLink: (url: string, label: string) => void;
};

export class QuickRepliesView {
  el: HTMLDivElement;

  constructor(replies: QuickReply[], callbacks: QuickReplyCallbacks) {
    this.el = h('div', { class: 'att-quick-replies', role: 'group', 'aria-label': 'Respostas rápidas' }) as HTMLDivElement;

    for (const reply of replies) {
      const chip = h('button', {
        class: 'att-quick-reply-chip',
        type: 'button',
      }, reply.label) as HTMLButtonElement;

      chip.addEventListener('click', () => {
        this.handleClick(reply, callbacks);
      });

      this.el.appendChild(chip);
    }
  }

  private handleClick(reply: QuickReply, callbacks: QuickReplyCallbacks): void {
    switch (reply.action) {
      case 'message':
        callbacks.onMessage(reply.value);
        this.hide();
        break;
      case 'whatsapp':
        callbacks.onWhatsApp(reply.value, reply.label);
        this.hide();
        break;
      case 'link':
        window.open(reply.value, '_blank', 'noopener,noreferrer');
        callbacks.onLink(reply.value, reply.label);
        break;
      case 'bot_node':
      case 'article':
        // TODO: v2
        break;
    }
  }

  hide(): void {
    this.el.style.display = 'none';
  }

  show(): void {
    this.el.style.display = '';
  }
}
